// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1b7d953a","546":"31659d2a"}[chunkId] + ".chunk.js";
};